<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="dialogRef.close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4 class="mt-0">JSON</h4>
</div>
<div mat-dialog-content class="dialog-content">
  <div class="json-wrap">
    <ngx-json-viewer [json]="dialogData.jsonContent"></ngx-json-viewer>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer">
  <div class="buttons-wrap">
    <button class="mat-green" (click)="dialogRef.close()" mat-raised-button>Close</button>
  </div>
</div>
